import React, { useState } from "react";
import "../styles/editor.scss";
import { SwatchesPicker } from "react-color"
import CreationPanel from "./CreationPanel";

export default function Editor() {
  const [panelWidth, setPanelWidth] = useState(16);
  const [panelHeight, setPanelHeight] = useState(16);
  const [hideOptions, setHideOptions] = useState(false);
  const [hideDrawingPanel, setHideDrawingPanel] = useState(true);
  const [buttonText, setButtonText] = useState("start drawing");
  const [selectedColor, setColor] = useState("#f44336");

  function drawingStartHandler(){
    setHideOptions(!hideOptions)
    setHideDrawingPanel(!hideDrawingPanel)

    buttonText === "start drawing"
      ? setButtonText("reset")
      : setButtonText("start drawing")

  }

  function changeColor(color){
    setColor(color.hex)
  }

  return (
    <div id="editor">
      <h1>Pixel Editor</h1>
      {hideDrawingPanel && <h2>Enter Panel Dimensions</h2>}
      {hideDrawingPanel && (<div id="options">
        <div className="option">
          <input
            type="number"
            className="panelInput"
            defaultValue={panelWidth}
            onChange={(element) => {
              setPanelWidth(element.target.value);
            }}
            max={100}
          ></input>
          <span>Width</span>
        </div>
        <div className="option">
          <input
            type="number"
            className="panelInput"
            defaultValue={panelHeight}
            onChange={(element) => {
              setPanelHeight(element.target.value);
            }}
            max={100}
          ></input>
          <span>Height</span>
        </div>
      </div>)}
      <button onClick={drawingStartHandler} className="button">{buttonText}</button>

      {hideOptions && (<SwatchesPicker height={200} color={selectedColor} onChangeComplete={changeColor}/>)}

      {hideOptions && (<CreationPanel width={panelWidth} height={panelHeight} selectedColor={selectedColor}/>)}
    </div>
  );
}
